import { render, staticRenderFns } from "./FlipBook.vue?vue&type=template&id=cd68a6c2&"
import script from "./FlipBook.vue?vue&type=script&lang=js&"
export * from "./FlipBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports